const en = {
  nightMode: 'Dark Mode',
  title: 'TokenPocket ETH Node Staking has been running stably for over 2 years, and the nodes it manages have stably generated rewards, leading the industry in node operation status, generating an annualized yield of approximately 5% for managed validators. Multiple staking methods, flexible participation methods',
  title_2: 'As of September 16, 2022, 00:00 UTC, users who have participated in TokenPocket Eth2.0 Staking Pool and have accumulated staking amounts greater than or equal to 0.1 ETH are eligible to receive the $STRK airdrop.',
  jointStake: 'Joint Staking',
  selfHostStake: 'Self-Custodial Staking',
  totalStake: 'Total Staked (ETH)',
  totalIncome: 'Accumulated Reward',
  estimateAnnualized: 'Estimated APY',
  yourEndpointTrend: 'Your Validators Rewards Trend',
  day: '24H',
  month: 'Last 30D',
  joinStake: 'Stake',
  quitStake: 'Unstake',
  inputQuitAmount: 'Please input the amount to unstake',
  canQuitAmount: 'The current available amount to unstake is: ',
  canFastQuitAmount: 'Available amount to fast unstake: ',
  quitKnow: '* About unstaking, please refer to',
  quitRules: '《Unstaking Rules》',
  confirmQuit: 'Confirm to unstake',
  remainingAmount: 'Remaining amount: ',
  inputJointStakeAmount: 'Please input the amount to join joint staking',
  jointStakeMinAmount: 'The minimum amount for joint staking is 0.1 ETH',
  joinAndAgree: 'Continue means agreeing to',
  stakeVaultServiceProtocol: '《Staking Vault Service Protocol》',
  pay: 'Confirm',
  endpointIncome: 'Validator Reward',
  endpointStatus: 'Validator Status',
  stakeHistory: 'Staking History',
  commonQuestion: 'Common Questions',
  knowledge: 'Knowledge',
  knowETHPOS: 'Learn about ETH POS',
  aboutStakeCommonQustions: 'Common questions of ETH Staking',

  endpont: 'Validator',
  stakeAmount: 'Staked Amount',
  validTime: 'Valid Time',
  withdrawalAddress: 'Withdrawal Address',
  receiveTime: 'Expected time of receipt',
  active: 'Active',
  connectWallet: 'Connect Wallet',
  balance: 'Balance',
  noData: 'Currently No Data',
  predictIncome: 'Estimated Validator Rewards: ',
  inputJointStakeAmount: 'Please input the amount to join joint staking',
  jointStakeTip: 'The minimal amount for joint staking is 0.1 ETH',
  overCount: 'Maximum amount is 32000 ETH',
  belowCount: 'Minimum amount is 0.1 ETH',
  overActivityCount: 'The amount you can quickly participate in is only {msg} ETH. If you need to participate in more, please stake the quick-effect amount first and then continue to participate in regular staking',
  activityEnd: 'The quick-staking event has ended, please continue to participate in regular staking',
  unknownError: 'Unknown Error',
  fail: 'Staking Failed',
  success: 'Successfully Participated',
  anonymousloginError: 'Network error, please try again',
  aboutUnstake: '* About exiting staking, please refer to<a style="color: #2980FE" href="https://help.tpwallet.io/en/wallet-faq-en/eth-wallet/eth2.0-staking-vault" target="_blank">《Unstaking Rules》</a>',
  aboutStake: 'Continue means agreeing to<a style="color: #2980FE" href="https://help.tpwallet.io/en/wallet-faq-en/eth-wallet/eth-2.0-staking-vault-service-agreement " target="_blank">《Staking Vault Service Protocol》</a>',
  deposit: 'Deposited, waiting for validator creation',
  staking: 'Staking (in progress)',
  unstaking: 'Staking (processing)',
  staked: 'Staked (Awaiting activation)',
  unstaked: 'Unstaked',
  withdrawal: 'Withdraw',
  endpointAmount: 'Number of validators',
  hasStaked: 'Has staked',
  hasUnstaked: 'Has unstaked',
  usedOut: 'The previous round of the liquidity fund has been used up, and the new round is being prepared. Please wait.',
  exitSuccess: 'Exit Success',
  exitFailed: 'Exit Failed',
  selfHostStakeWarn: 'Set the number of validators for staking, each validator requires 32 ETH for staking.',
  needToStakeAmount: 'Amount to Stake',
  endpointStake: 'Validator Staking',
  endpointMaintainFee: 'Maintenance Fee',
  amount: 'Number of Validator',
  one: 'Validator',
  totalFee: 'Fee',
  feeDetails: 'Payment Details',
  endpointCount: 'Number of validators',
  mobileSelfHostStakeDesc: 'You will hold the withdrawal private key yourself and need to stake at least 32 ETH each time.',
  mobileJointStakeDesc: 'Joint staking with others, each stake requires at least 0.1 ETH.',
  stakeOrUnstake: 'Stake/Unstake',
  myEndpoints: 'My Validators',
  switchWallet: 'Switch Wallet',
  settings: 'Settings',
  switchLocale: 'Languages',
  overAccount: 'Insufficient balance',
  effectiveTime: 'Effective Time',
  copied: 'Copied',
  endpointStatusMap: {
    0: 'Pending',
    1: 'Queuing in staking',
    2: 'Effective',
    3: 'Unstaking',
    4: 'Withdrawing',
    5: 'Exited',
  },
  consensusIncome: 'Consensus Reward',
  executionIncome: 'Execution Reward',
  total: 'Total Reward',
  networkError: 'Wrong network, change your network',
  quitMax1: 'Liquidity fund amount for today: ',
  quitMax2: 'Maximum exit amount for today: ',
  quitMax3: 'Your staked amount: ',
  quitMin: 'Minimum exit amount: ',
  forever: 'Permanent',
  sendKeypal: 'Get a hardware wallet free',
  editAddress: 'shipping address',
  inputAddress: 'Enter location',
  receivePerson: 'Recipient',
  name: 'Name',
  phoneNumber: 'Phone Number',
  inputPhoneNumber: 'Input your phone number',
  emailCode: 'Postal Code',
  addressDetails: 'Location details',
  viewAllEndpoints: 'View all validators',
  endpointListUrl: 'https://help.tpwallet.io/en/wallet-faq-en/eth-wallet/eth2.0-node-list ',
  posUrl: 'https://help.tokenpocket.pro/en/wallet-faq-en/eth-wallet/pos',
  commonQuestionUrl: 'https://help.tokenpocket.pro/en/wallet-faq-en/eth-wallet/about-eth-staking',
  selfHostCommonQuestionUrl: 'https://help.tokenpocket.pro/en/wallet-faq-en/eth-wallet/about-self-custodial-staking',
  confirm: 'Confirm',
  txConfirming: '{amount} transaction(s) confirming...',
  endpointFeeTip: 'The validator maintenance fee is charged as a one-time fee and no additional fees will be charged in the future.',
  noHistoryData: 'Oops, there is no staking records',
  noEndpointData: 'No validators, get one now~',
  tips: 'Prompt',
  downloadTips: 'Please download TokenPocket to access it, websites:',
  know: 'Okay',
  unknownError: 'Unknown error',
  email: 'Email',

  quit: 'Fast', 
  normal: 'Common', 
  incomeTitle: 'Withdrawl reward', 
  withdrawAmount: 'Withdrawl amount', 
  withdraw: 'Withdraw', 
  estimateGas: 'Maximal withdrawl gas fee', 
  withdrawSuccess: 'Withdraw Success',
  withdrawFailed: 'Withdraw Failed',
  
  withdrawIncomeTips: 'TokenPocket has requested the reward to beacon chain, after confirmed, you can withdraw your reward.', 
  unStakeSuccess: 'Unstaked request sent, after confirmed on chain, you can withdraw from the withdrawal button below.', 
  quitHandlingFee: 'Fast unstake will charge 5% as the fee', 
  normalQuit: 'Common',
  fastQuit: 'Fast (Liquidity Fund)',
  withdrawTips: "Network fee is higher than withdrawal amount, please don't continue",
  
  modalTextData: { 
    title_1: 'Withdraw Reward', 
    desc_1: 'Validator rewards can be withdrawn after confirmation on the Ethereum beacon chain, which may involve queuing. TokenPocket will deduct the withdrawal fee when the withdrawal request is confirmed.', 
    btn_1: 'Okay', 
    
    title_2: 'About Common Unstake', 
    desc_2: '  As validator staking and unstake require confirmation through the Ethereum beacon chain, which may involve queuing. Once TokenPocket stakes or unstakes on behalf of the user and gets confirmed on the chain, the user can withdraw their stake.', 
    btn_2: 'Okay', 

    title_3: 'Warm Reminder',
    desc_3: "ETH Staking Vault will undergo a system upgrade from 1:00 PM UTC, May 22nd to 4:00 AM UTC, May 23nd. The service will be temporarily suspended during the upgrade period. Your validator's security will not be affected, please rest assured. After the upgrade is completed, you will be able to use the service as usual!",
    btn_3: 'Okay',
  },

  details: 'Details',
  selfHostIncomeUrl: 'Auto crediting',

  self_host_op_type: {
    1: 'Staked',
    2: 'Unstaked',
    3: 'Platform Withdrawal',
    4: 'On-chain Withdrawa',
    5: 'Fast Staking',
    6: 'Fast Withdrawal',
    7: 'Insufficient Fast Staking (Partial Refund)',
  }
};

export default en;
